"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_image_magnify_1 = __importDefault(require("react-image-magnify"));
var ZoomableImage = function (props) {
    var className = props.className, smallImage = props.smallImage, largeImage = props.largeImage, alt = props.alt, title = props.title, isDisabled = props.isDisabled;
    var _a = (0, react_1.useState)({ width: 0, height: 0 }), dimensions = _a[0], setDimensions = _a[1];
    var onLoad = function (_a) {
        var img = _a.target;
        var multiplier = 1.2;
        setDimensions({
            width: img.naturalWidth * multiplier,
            height: img.naturalHeight * multiplier,
        });
    };
    var onLoadSmallImage = function (_a) {
        var img = _a.target;
        img.classList.add('auto-height');
        img.setAttribute('title', title);
    };
    return (react_1.default.createElement("div", { className: className }, isDisabled ? (react_1.default.createElement("img", { loading: "lazy", src: smallImage, alt: alt, title: title })) : (react_1.default.createElement(react_image_magnify_1.default, __assign({}, {
        smallImage: {
            alt: alt,
            title: title,
            isFluidWidth: true,
            src: smallImage,
            onLoad: onLoadSmallImage,
        },
        largeImage: {
            src: largeImage,
            width: dimensions.width,
            height: dimensions.height,
            onLoad: onLoad,
        },
        enlargedImagePortalId: 'portal',
        enlargedImageContainerDimensions: {
            width: '80%',
            height: '80%',
        },
        fadeDurationInMs: 0,
        hoverDelayInMs: 0,
        hoverOffDelayInMs: 0,
        pressDuration: 100000,
        lensStyle: {
            background: 'rgba(255, 255, 255, 0.5)',
        },
    })))));
};
exports.default = ZoomableImage;
